import { DateTime } from 'luxon';
import { Pipe, PipeTransform } from '@angular/core';
import { TranslationService } from '../services/translation.service';

@Pipe({
  name: 'fixDateUTC',
  standalone: false
})
export class FixDateUTC implements PipeTransform {

  constructor(private translateService: TranslationService) { }

  transform(value: Date | string | any, optionFormat?: number): string {
    if (!value) return '--';

    const formatDate = optionFormat === 2 ? 'dd/LL/yyyy' : 'dd/LLL/yyyy';

    let dateTime: DateTime;

    try {
      if (value instanceof Date) {
        // Parseamos como UTC para evitar desfase al guardar
        dateTime = DateTime.fromJSDate(value, { zone: 'utc' });
      } else if (typeof value === 'string') {
        // Intentamos ISO primero
        dateTime = DateTime.fromISO(value, { zone: 'utc' });

        // Si falla, intentamos formato dd/MM/yyyy
        if (!dateTime.isValid) {
          const [day, month, year] = value.split('/').map(Number);
          if (day && month && year) {
            dateTime = DateTime.fromObject({ day, month, year }, { zone: 'utc' });
          }
        }
      } else {
        return '--';
      }

      if (!dateTime.isValid) return '--';

      const locale = this.translateService?.currentLang || 'es';

      // Convertimos a zona local solo al mostrar
      return dateTime
        .setZone('local')   // <--- importante
        .setLocale(locale)
        .toFormat(formatDate)
        .toUpperCase();

    } catch (error) {
      console.error('Error en fixDateUTC pipe:', error);
      return '--';
    }
  }
}
